import React from 'react';
import LazyUniversalComponent from 'Components/LazyUniversalComponent/LazyUniversalComponent';
import * as flows from './../flows/async';

const getSecurityRoute = config => {
    const hasSecurityPages = config?.hasSecurityPages;

    // if route is not enabled from config and no finance sub-route is present return empty
    if (hasSecurityPages) {
        return [
            {
                path: 'security',
                children: [
                    {
                        path: 'vulnerability-disclosure-program',
                        element: <LazyUniversalComponent
                            component={ flows.importSecurityProgramPage() }
                        />
                    },
                    {
                        path: 'VDP-hall-of-fame',
                        element: <LazyUniversalComponent
                            component={ flows.importSecurityHOFPage() }
                        />
                    }
                ]
            }
        ];
    }

    return [];
};

export default getSecurityRoute;
